import InputMoney from "../../../../../../../common/components/form/CurrencyInputFormik";
import InputFormik from "../../../../../../../common/components/form/InputFormik";
import TextAreaFormik from "../../../../../../../common/components/form/TextAreaFormik";
import { maskLicensePlate } from "../../../../../../../common/helpers/mask.helpers";


export function FormBillingFine() {
  return (
    <div>
      <div className="grid grid-cols-2 gap-2">

        <InputMoney
          label="Valor da multa:"
          name="value"
          required={true}
        />
        <InputFormik
          label="Placa do veículo:"
          name="licensePlate"
          type="text"
          className="col-span-1"
          required={true}
          mask={maskLicensePlate}
        />
      </div>

      <InputFormik
        className="mt-4"
        label="Data de cobrança da primeira parcela - Assinatura"
        name="nextDueDate"
        type="date"
        required={true}
      />

      <TextAreaFormik
        className="mt-4 flex-1"
        name="description"
        label="Descrição da multa de trânsito"
        placeholder="Descrição"
      />
    </div>
  );
}